import React, { useEffect, useState } from "react";
import styles from "./BlogPost.module.css";
import { Link } from "react-router-dom";
import { BsArrowRightCircle } from "react-icons/bs";
import axiosPrivate from "../../../hooks/axiosPrivate";
import { useLocation } from "react-router-dom";
import { GiWoodenClogs } from "react-icons/gi";
import moment from "moment";
import LoaderContext from "../../../context/Loader/LoaderContext";
import { useContext } from "react";
import { showErrorToast } from "../../../Toster";
import HeaderWithLeaf from "../../HeaderWithLeaf";
import PageTitleWithLeaf from "../../PageTitleWithLeaf";

function BlogPost({ initialValues }) {
  const BlogPath = "/blog-listing";
  const location = useLocation();
  const [hide, setHide] = useState(location.pathname !== BlogPath);
  const [Blog, setBlog] = useState([]);
  
  const { setLoaderCheck } = useContext(LoaderContext);
  const [enquiryState, setEnquiryState] = useState([]);
  const latestThreeBlogs = Blog?.slice(0, 3);
  const restOfTheBlogs = Blog?.slice(3);

  useEffect(() => {
    if (location.pathname === BlogPath) {
      const mainContainer = document.querySelector("#mainContainer");
      mainContainer.style.marginTop = "0px";
    }
  }, [location.pathname]);

  const toggleViewMore = () => {
    setHide((prev) => !prev);
  };

  useEffect(() => {
    const options = {
      headers: { "content-type": "application/json" },
    };
    setLoaderCheck(true);
    axiosPrivate
      .get(`/blogs`, options)
      .then((blog) => {
        setLoaderCheck(false);
        setBlog(blog.data.data);
      })
      .catch((error) => {
        setLoaderCheck(false);
        if (error.response) {
          showErrorToast("Internal Server Error");
        }
      });
  }, []);

  function getFormattedDate(date) {
    const splitDate = moment(date).format("	LL").split(",");
    const publishedDate = splitDate[0].split(" ");
    return publishedDate[1];
  }

  function getFormattedMonth(date) {
    const splitDate = moment(date).format("	LL").split(",");
    const publishedDate = splitDate[0].split(" ");
    return publishedDate[0];
  }

  return (
    <div
      // style={{ display: "none" }}
      id="mainContainer"
      className={`px-0 mx-0 relative ${location.pathname === BlogPath ? "blogMargin" : ""
        } section-p-spacing-top`}
    >
      <img
        src="../assets/images/home/Group 244.webp"
        alt="Background"
        loading="lazy"
        className={styles.background}
      />
      {location.pathname === "/" ? (
        <HeaderWithLeaf text={initialValues?.mainHeading} />
      ) : (
        <PageTitleWithLeaf text={initialValues?.mainHeading} />
      )}

      {initialValues?.mainContent ? (
        <p className={styles.mainContent}>{initialValues?.mainContent}</p>
      ) : null}

      <div className={`container ${styles.blogs}`}>
        <div className="row">
          {[...latestThreeBlogs, ...(hide ? [] : restOfTheBlogs)]?.map((post, index) => {
            return (
              <div className="col-lg-4 col-md-6 col-12 mb-4" key={post.id || index}>
                <div className={`${styles.blogContainer} h-100`}>
                  <div className="col">
                    <div className="row">
                      <div className={`position-relative ${styles.blogImg}`}>
                        <img
                          className="img-fluid w-100"
                          style={{aspectRatio:"2/1"}}
                          src={
                            process.env.REACT_APP_COMMON_FILE_URL +
                            "blogs/" +
                            post?.featured_image
                          }
                          alt={post?.alt}
                          loading="lazy"
                        />
                        <div className={styles.date}>
                          <h4 className={styles.postDate}>
                            {getFormattedDate(post?.publish_date)}
                          </h4>
                          <p className={styles.postMonth}>
                            {getFormattedMonth(post?.publish_date)}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className={`${styles.blogContent} d-flex flex-column h-100`}
                      >
                        <div>
                          <h3
                            className={styles.blogHeading}
                            dangerouslySetInnerHTML={{
                              __html: post?.short_description.slice(0, 50),
                            }}
                          ></h3>

                          <div
                            className={styles.postContent}
                            dangerouslySetInnerHTML={{
                              __html:
                                post?.description.length > 350
                                  ? post?.description.slice(0, 350) + "..."
                                  : post?.description,
                            }}
                          ></div>
                          <Link to={`/blog-detail/${post.slug}`}>
                            <button
                              style={{
                                background: "var(--green)",
                                color: "white",
                                padding: "8px 16px",
                                border: "none",
                                cursor: "pointer",
                              }}
                              onClick={toggleViewMore}
                            >
                              Read more
                            </button>
                          </Link>
                        </div>
                        {/* <div className={`${styles.writer} mt-auto`}>
                          <div className={styles.writerImage}>
                            <img
                              src="../favIcon.png"
                              alt="Writer name"
                              loading="lazy"
                            />
                          </div>
                          <h6 className={styles.writerName}>Minfert</h6>
                        </div> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
      {hide && (
        <div className={styles.viewButtonContainer}>
          <Link to="/blog-listing">
            <button
              style={{
                background: "var(--green)",
                color: "white",
                padding: "8px 16px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={toggleViewMore}
            >
              {initialValues?.viewMoreBlogBtn}
            </button>
          </Link>
        </div>
      )}
      {hide && restOfTheBlogs > 0 && (
        <div className={styles.viewButtonContainer}>
          <Link to="/blog-listing">
            <button
              style={{
                background: "var(--green)",
                color: "white",
                padding: "8px 16px",
                border: "none",
                cursor: "pointer",
              }}
              onClick={toggleViewMore}
            >
              {initialValues?.viewMoreBlogBtn}
            </button>
          </Link>
        </div>
      )}
    </div>
  );
}

export default React.memo(BlogPost); // Memoize the BlogPost;
